export default "__VITE_ASSET__BFJqJlEi__"